var has;var hasRequiredHas;function requireHas(){if(hasRequiredHas)return has;hasRequiredHas=1;has=Function.call.bind(Object.prototype.hasOwnProperty);return has}

export { requireHas as __require };
//# sourceMappingURL=has.js.map
